var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-qr", {
    attrs: {
      text: _vm.value,
      logoScale: 50,
      size: _vm.size ? _vm.size : 200,
      whiteMargin: _vm.whiteMargin === false ? false : true
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }